import {
  SHOW_MODAL,
  HIDE_MODAL,
} from './types'

const showReduxModal = (modal) => ({
  type: SHOW_MODAL,
  modal
});

export const showModal = (modal) => dispatch => {
  dispatch(showReduxModal(modal))
}

export const hideModal = () => ({
  type: HIDE_MODAL
});



// WEBPACK FOOTER //
// ./src/actions/modal.js